<template>
    <div>
        <base-header type="instore" class="pb-6 pb-8 pt-5 pt-md-8">
        </base-header>
        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <div class="card mb-3">
                        <div class="row no-gutters" v-if="currentProfile == 'in_app_notifications' && accessRights.includes('V')">
                            <div class="col-md-3" style="border-right: 1px solid #e0e0e0">
                              <div class="card-body">
                                  <filter-bar-v2 @changeFilter="changeFilter" @update:site_id="site_id = $event" :key="statusKey"></filter-bar-v2>
                              </div>
                            </div>
                            <div class="col-md-9">
                              <div  class="card-body" v-if="currentProfile == 'in_app_notifications' && accessRights.includes('V')" >
                                  <pos-alert-notifications-table :siteId="site_id"   :status="filterStatus" :key="formKey" :accessRights="accessRights"></pos-alert-notifications-table>
                              </div>
                            </div>
                        </div>
                        <div class="row no-gutters" v-else>
                            <div class="card-body">
                                <a-empty class='mt-5' :image-style="{ height: '50px', }">
                                    <span slot="description"> No access </span>
                                </a-empty>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import HTTPRequest from '../../controllers/httpRequest.js'
import PosAlertNotificationsTable from '../Tables/SystemNotificationsTable.vue'
import FilterBarV2 from '../FilterBarV2'  
import secureStorage from '../../controllers/secureStorage';

import { mapState, mapActions } from 'vuex'

export default {
    components: {
        PosAlertNotificationsTable,
        FilterBarV2
    },
    data: function(){
        return {
            filterStatus: "",
            componentKey: 0,
            formKey: 0,
            activeModules: [],
            accessRights: [],
            profileId: null,
            accessRights: [],
            statusKey: 0,
            site_id: secureStorage.getItem("defaultSiteId")
        }
    },
    watch:{
        $route: async function (to, from) {
            await this.loadPage();
        }
    },
    mounted: async function() {
        this.loadPage();
    },
    computed: {
        ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
    },
    methods: {
        ...mapActions(['updateCurrentProfile', 'updateParameters']),
        async loadPage() {
          var providedFilter = this.$route.query.type
            if(providedFilter.includes("SN-"))
                var categoryId = await HTTPRequest.getRequest(this.endPoint + '/system_module_categories?code=MCS-007', null, null)  

            this.activeModules = await HTTPRequest.getRequest(this.endPoint + '/system_module_categories/' +  categoryId[0].id + '/enabled_modules', null, null)
            if( this.activeModules.length > 0 ){
                var profile = _.snakeCase(this.activeModules[0].name)
                this.setCurrentProfile(_.pluralize(profile), this.activeModules[0].id);
            } else {
                this.setCurrentProfile(null,null);
                this.formKey++
            }

            if(providedFilter.includes("DA-") || providedFilter.includes("SA-")){
               this.gradientType = "instore"
               this.buttonType = "success"
            }else{
               this.gradientType = "instore"
               this.buttonType = "success"
            }
        },
        async setCurrentProfile(profile, id){
            if(profile == "salesmans")
                profile = "salesmen"

            this.profileId = id
            var accessRightsRequest = await HTTPRequest.getRequest(this.endPoint + 'users/' + secureStorage.getItem("userId") + "/access_rights?system_module_id=" + id, null)

            if (_.isEmpty(accessRightsRequest.access_rights) == false){
                this.accessRights = accessRightsRequest.access_rights[id]
                
            }else {
                this.accessRights = []
            }
            this.updateCurrentProfile(profile)
            this.componentKey++;
            this.formKey++;
            // alert(this.accessRights.toString())
        },
        changeFilter(statusFilter, searchFilter, searchText) {
            this.filterStatus = statusFilter
            this.updateParameters(searchText[0] == "&" ? "?" + searchText.slice(1) : "?" + searchFilter + "=" + searchText)
        },
    }
}
</script>
